import { Button, Datepicker, Pagination, Table } from "flowbite-react";
import { useCallback, useEffect, useState } from "react";
import NotificationRow from "./NotificationRow";
import toast from "react-hot-toast";
import { getNotifications } from "../../api/notifications";
import moment from "moment";

const Notifications = () => {
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const columns = ['Influencer', 'Last reply', 'Campaign name', 'Stage', 'Status', 'Actions'];
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [date, setDate] = useState('');

  const fetchNotifications = useCallback(async (date) => {
    setLoading(true);

    try {
      const _notifications = await getNotifications({ page, date });

      setNotifications(_notifications.notifications);
      setTotalPages(_notifications.totalPages);
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || error.message || 'Failed to fetch notifications');
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    fetchNotifications(date);
  }, [fetchNotifications, date]);

  const handleDateChange = (value) => {
    console.log(value);
    setDate(moment(value).format('YYYY-MM-DD'));
  }

  return (
    <>
      <div className="flex gap-2 justify-between items-center border-b border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">Notifications</h1>
        <div className="flex gap-2">
          <Datepicker
            value={date}
            onSelectedDateChanged={handleDateChange}
            showClearButton={false}
          />
          <Button onClick={() => setDate('')}>Clear</Button>
        </div>
      </div>

      {loading ? (
        <div className="mt-8 text-center text-gray-600">Loading notifications...</div>
      ) : notifications.length ? (
        <>
          <div className="overflow-x-auto">
            <Table>
              <Table.Head>
                {columns.map((column, key) => (
                  <Table.HeadCell key={key}>{column}</Table.HeadCell>
                ))}
              </Table.Head>
              <Table.Body className="divide-y">
                {notifications.map((notification) => (
                  <NotificationRow
                    notification={notification}
                    key={notification._id}
                  />
                ))}
              </Table.Body>
            </Table>
          </div>

          {totalPages > 1 && (
            <div className="sticky bottom-0 right-0 w-full items-center border-t border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex sm:justify-between">
              <Pagination
                currentPage={page}
                totalPages={totalPages}
                onPageChange={(value) => setPage(value)}
              />
            </div>
          )}
        </>
      ) : (
        <div className="mt-8 text-center text-gray-600">No notifications found</div>
      )}
    </>
  );
}

export default Notifications;